import {connect} from "react-redux";
import FastRoomEdit from "./FastRoomEdit";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {addRoom, clearRoom, getFields, getRoomById, getTypeList, updateRoom} from "../../ObjectRoomEdit/actions";
import {getRoomsList} from "../../../globalState/object/actions";
import {getRoomPhotoApprovedToDB} from "../../ObjectRoomEdit/selector";


let mapStateToProps = (state) => {
    return {
        objectId: state.object.id,
        roomMain: state.objectRoomEdit.roomMain,
        typesList: state.objectRoomEdit.typesList,
        country: state.object.country,
        roomPhotoApprovedToDB: getRoomPhotoApprovedToDB(state),
    }
};

export default compose(connect(mapStateToProps, {
    getRoomById,
    getTypeList,
    getFields,
    clearRoom,
    updateRoom,
    addRoom,
    getRoomsList,
}), withRouter)(FastRoomEdit);




